<template>
  <span class="app-tag" :class="'app-tag--' + kindName"><slot>{{ defaultText }}</slot></span>
</template>

<script>
// Tag (Spezifikation 2.6, R4): kind="storno" (#fdeceb/#b42318), kind="test" (seit 13.10.2026 Amber --amber-t/--amber,
// vorher #eef0f3/#3a4250) und kind="off" (#eef0f3/#3a4250, Kundenwunsch 13.10.2026 für „Inaktiv“).
// 18 px hoch, 11/16 600, nicht klickbar. Ohne Slot steht „Storno“, „Test“ bzw. „Inaktiv“.
export default {
  name: 'AppTag',
  props: {
    kind: { type: String, default: 'storno' }
  },
  computed: {
    kindName() {
      return this.kind === 'test' || this.kind === 'off' ? this.kind : 'storno';
    },
    defaultText() {
      return { test: 'Test', off: 'Inaktiv', storno: 'Storno' }[this.kindName];
    }
  }
};
</script>
